import { configureStore } from '@reduxjs/toolkit';
import { getHostname } from '../helpers';
// Reducers
import { reducer } from './reducer';

const enableReduxDevtools = getHostname()?.includes('localhost');

export const store = configureStore({ reducer, devTools: enableReduxDevtools });

// Infer the `RootState` and `AppDispatch` types from the store itself
export type IRootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type IAppDispatch = typeof store.dispatch;
